export const infoBadgeConfig = {
    verizonLoyalty: {
        tooltipText: `Eligible customers may receive a one-month Verizon
Mobile Protect credit, applied through ACSS.`,
        offerText: `Verizon loyalty offer`,
    },
    // Future partner configs can be added here
} as const;

export type InfoBadgeType = keyof typeof infoBadgeConfig;
